import { clone } from "lodash";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { MachineConfiguration } from "../../../shared/models/machineConfiguration";
import { CloneAndConversionService } from "../../../shared/services/cloneAndConversionService";
import { MachineThreeRivers } from "../../models/machine";
import { MachineConfigurationThreeRivers } from "../../models/machineConfiguration";
import { IQService } from "angular";

export const vsServiceName = "cloneAndConversionService";

export class CloneAndConversionServiceThreeRivers extends CloneAndConversionService<
  MachineThreeRivers,
  MachineConfigurationThreeRivers
> {
  static $inject = [ServerUtilityName, "$q"];
  constructor(serverUtility: ServerUtility, $q: IQService) {
    super(serverUtility, $q);
  }

  protected override prepareCloneConfiguration(
    cloneConfiguration: MachineConfigurationThreeRivers
  ): MachineConfigurationThreeRivers {
    cloneConfiguration = super.prepareCloneConfiguration(cloneConfiguration);
    cloneConfiguration.Section =
      cloneConfiguration.Bank =
      cloneConfiguration.Position =
      cloneConfiguration.WarehouseLocation =
      cloneConfiguration.MachineBankConfigId =
      cloneConfiguration.MachineAreaId =
      cloneConfiguration.Date =
      cloneConfiguration.InServiceDate =
        undefined;

    return cloneConfiguration;
  }

  protected override prepareConversionConfiguration(
    conversionConfiguration: MachineConfigurationThreeRivers,
    currentConfiguration: MachineConfigurationThreeRivers
  ): MachineConfigurationThreeRivers {
    return {
      ...super.prepareConversionConfiguration(
        conversionConfiguration,
        currentConfiguration
      ),
      InServiceDate: currentConfiguration.OnFloorDate,
      WarehouseLocation: currentConfiguration.WarehouseLocation,
      MachineBankConfigId: currentConfiguration.MachineBankConfigId,
      MachineBankConfig: currentConfiguration.MachineBankConfig,
      MachineAreaId: currentConfiguration.MachineAreaId,
      MachineArea: currentConfiguration.MachineArea,
    };
  }
}
